export enum SettingsType {
  OpenAI = 'openai',
  ARAS = 'aras',
  FRONTEND = 'frontend',
  HEPSIJET = 'hepsijet',
  MNG = 'mng',
  MAIL_SERVER = 'mail_server',
  MAIL_NOTIFICATION = 'mail_notification',
  NOTIFICATION = 'notification',
  SHIPMENT = 'shipment',
  SMS = 'sms',
  STORE = 'store',
  BOYNER = 'boyner',
  TRENDYOL = 'trendyol',
  HEPSIBURADA = 'hepsiburada',
  N11 = 'n11',
  PAZARAMA = 'pazarama',
  CICEKSEPETI = 'ciceksepeti',
  POINT_SYSTEM = 'point_system',
  PRICE_ROUNDING = 'price_rounding',
  PARAM_POS = 'param_pos',
  ZIRAAT_POS = 'ziraat_pos',
  HALKBANK_POS = 'halkbank_pos',
  BANK_TRANSFER = 'bank_transfer',
  PAYMENT_PROVIDER = 'payment_provider',
  AT_CHECKOUT_DISCOUNT = 'at_checkout_discount',
  UYUMSOFT = 'uyumsoft',
  INVOICE = 'invoice',
}
